import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Wordmark } from "@/components/MoonMark";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { Twitter, Send, Copy, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function MilestoneCard() {
  const { id } = useParams();
  const [m, setM] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/m/${id}`).then(({ data }) => setM(data)).catch(() => setErr(true));
  }, [id]);

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";
  const tweetHref = m
    ? `https://twitter.com/intent/tweet?text=${encodeURIComponent(m.tweet_text)}&url=${encodeURIComponent(shareUrl)}`
    : "#";
  const tgHref = m
    ? `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(m.tweet_text)}`
    : "#";

  if (err) return <Centered><p className="text-dust">Milestone not found.</p></Centered>;
  if (!m) return <Centered><p className="text-dust">Loading…</p></Centered>;

  return (
    <div className="min-h-screen bg-ink text-cream grain">
      <header className="flex h-16 items-center justify-between border-b border-line glass px-5 lg:px-10">
        <Link to="/"><Wordmark /></Link>
        <Link to="/burns"><Button variant="outline" className="gap-2 border-line bg-surface hover:bg-raised"><ArrowLeft size={15} /> Burns</Button></Link>
      </header>

      <div className="mx-auto max-w-2xl px-5 py-16">
        <div className="overflow-hidden rounded-3xl border border-line bg-gradient-to-br from-surface to-ink p-10 text-center shadow-2xl" data-testid="milestone-card">
          <div className="mb-4 text-6xl">{m.icon}</div>
          <p className="text-xs uppercase tracking-[0.3em] text-dust">Wen Moon milestone</p>
          <h1 className="mt-3 text-4xl font-black tracking-tight sm:text-5xl" data-testid="milestone-ticker">${m.ticker}</h1>
          <p className="mt-4 text-lg text-cream" data-testid="milestone-headline">
            {m.label} crossed <span className="font-mono font-bold text-juice">${Number(m.tier).toLocaleString()}</span>
          </p>
          {m.ca && m.ca !== "pending" && (
            <button onClick={() => { navigator.clipboard.writeText(m.ca); toast.success("CA copied"); }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-line bg-raised px-3 py-1.5 font-mono text-xs text-dust hover:text-cream" data-testid="milestone-ca">
              <Copy size={12} /> {m.ca.slice(0, 10)}…{m.ca.slice(-6)}
            </button>
          )}
          <p className="mt-6 text-sm text-dust">Launched by Wen Moon 🚀</p>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <a href={tweetHref} target="_blank" rel="noreferrer" data-testid="milestone-share-x">
            <Button className="gap-2 bg-juice font-semibold text-ink hover:bg-juice/90"><Twitter size={16} /> Share to X</Button>
          </a>
          <a href={tgHref} target="_blank" rel="noreferrer" data-testid="milestone-share-tg">
            <Button variant="outline" className="gap-2 border-line bg-surface hover:bg-raised"><Send size={16} /> Share to Telegram</Button>
          </a>
          <Button variant="outline" onClick={() => { navigator.clipboard.writeText(shareUrl); toast.success("Link copied"); }} className="gap-2 border-line bg-surface hover:bg-raised" data-testid="milestone-copy-link">
            <Copy size={16} /> Copy link
          </Button>
        </div>
      </div>
    </div>
  );
}

const Centered = ({ children }) => (
  <div className="flex min-h-screen items-center justify-center bg-ink text-cream">{children}</div>
);
